import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import FooterProfile from '../components/footer_profile';
import styles from './listings.module.css';
import { orderStatus } from '../utils/utils';
import isLoggedIn from '../utils/isLoggedIn';
import Navbar from '../components/navbar';
import OrderFilter from '../components/order_filter';

const Orders = () => {
  //set initial states, comics, characters and query filters
  const url = `${process.env.REACT_APP_API}`;
  const token = sessionStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({
    country: '',
    searchStr: '',
    processId: '',
    displayCount: 20,
    page: 1,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch()

  //Get all products and equipments to display -------------\\
  useEffect(() => {
    const getRequests = async () => {
      const { searchStr, processId, displayCount, page } = filters;
      // Get listings on page load..
      const response = await axios.get(
        `${url}/admin/orders?searchStr=${searchStr}&processId=${processId}&displayCount=${displayCount}&page=${page}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      const [count, orders] = response.data;
      setOrders(orders);
      setCount(count);

      setLoading(false);
    };

    //Check if user is logged in with a valid token
    isLoggedIn(navigate, dispatch, '/store/orders');
    const timeoutId = setTimeout(() => {
      getRequests();
    }, 300);

    return () => {
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [filters]);

  // Component return .. .. COMIC or CHARACTER;;
  return isLoading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS:Received orders</title>
        <meta name='page' content='received orders' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    //All products .. map and render products table
    <>
      <Helmet>
        <title>Badgers SAS: Received orders</title>
        <meta name='page' content='received orders' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className=''>
        <OrderFilter
          count={count}
          filters={filters}
          setFilters={setFilters}
          displayMob={true}
        />
        <div className='container'>
          <div>
            <Link className='page-links' to='/'>
              <FontAwesomeIcon icon='home' />{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <Link className='page-links' to='/store'>
              STORE{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <span className='link-span'>RECEIVED ORDERS</span>
          </div>

          <div className='container'>
            <div className='col-12 d-flex justify-content-center my-4'>
              <h4 className='h4'>
                RECEIVED ORDERS <FontAwesomeIcon icon='shopping-cart' />
              </h4>
            </div>

            <table className='table table-striped table-hover'>
              <thead>
                <tr className={`${styles.headings}`}>
                  <th scope='col'>#</th>
                  <th scope='col'>Order ID</th>
                  <th scope='col'>Order Date</th>
                  <th scope='col'>Buyer</th>
                  <th scope='col'>Country</th>
                  <th className='text-center' scope='col'>
                    Total
                  </th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Updated at</th>
                </tr>
              </thead>
              <tbody>
                {orders.length > 0 ? (
                  orders.map((order, idx) => {
                    return (
                      <tr
                        key={order.id}
                        className={`${styles.rows} ${
                          order.statut === 1
                            ? 'table-primary'
                            : order.statut === 3
                            ? 'table-danger'
                            : order.statut === 7
                            ? 'table-success'
                            : null
                        }`}
                        onClick={() => navigate(`/store/order/${order.id}`)}
                      >
                        <th scope='row'>{idx + 1}</th>
                        <td>{order.id}</td>
                        <td>
                          {new Date(order.orderDate).toLocaleString('en-UK', {
                            dateStyle: 'short',
                          })}
                        </td>
                        <td>{`${order.User.prenom} ${order.User?.nom}`}</td>
                        <td>{order.User?.pays}</td>
                        <td className='text-end'>{`${order.payment[0]?.total} ${
                          order.payment[0]?.currency === 'usd' ? 'US$' : '€'
                        }`}</td>
                        <td>{orderStatus(order.statut)}</td>
                        <td>
                          {new Date(order.updatedAt).toLocaleString('en-UK', {
                            dateStyle: 'short',
                            timeStyle: 'short',
                          })}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={11}>No orders to display ...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <FooterProfile />
      </div>
    </>
  );
};

export default Orders;
